<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="10">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('table_label_placeholder') ||
                  '产品SKU编号/产品条码号/仓库SKU编号/仓库条码号/自定义编号 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-info"
              @click="$emit('putShelves')"
              v-if="allow('A')"
            >
              {{ $l('btn_add_sku') || '新增' }}
            </b-button>
            <el-badge :value="checkedCount" class="ml-2" v-if="allow('P')">
              <b-button
                size="sm"
                variant="outline-success"
                @click="$emit('batchListing')"
                :disabled="!checkedCount"
              >
                {{ $l('btn_batch_listing') || '批量上架' }}
              </b-button>
            </el-badge>
            <el-badge :value="checkedCount" class="ml-2" v-if="allow('S')">
              <b-button
                size="sm"
                variant="outline-warning"
                @click="$emit('bulkDeactivation')"
                :disabled="!checkedCount"
              >
                {{ $l('btn_bulk_deactivation') || '批量停用' }}
              </b-button>
            </el-badge>
            <el-badge :value="checkedCount" class="ml-2" v-if="allow('R')">
              <b-button
                size="sm"
                variant="outline-success"
                @click="$emit('batchRecovery')"
                :disabled="!checkedCount"
              >
                {{ $l('btn_batch_recovery') || '批量恢复' }}
              </b-button>
            </el-badge>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-drawer
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      show-close
      :visible.sync="advqueryDialogVisible"
      size="600px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="ml-4 mr-4">
        <el-form ref="form" :model="form" label-position="left" size="mini">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item :label="$l('INDEX.Status') || '状态'">
                <el-checkbox-group v-model="form.invSkuSetStatusList">
                  <el-checkbox label="N">{{
                    $l('check_status_N') || '新增'
                  }}</el-checkbox>
                  <el-checkbox label="W">{{
                    $l('check_status_W') || '待推送'
                  }}</el-checkbox>
                  <el-checkbox label="Y">{{
                    $l('check_status_Y') || '已上架'
                  }}</el-checkbox>
                  <el-checkbox label="S">{{
                    $l('check_status_S') || '已停用'
                  }}</el-checkbox>
                  <el-checkbox label="D">{{
                    $l('check_status_D') || '已删除'
                  }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('header_label_evgSkuNo') || '产品SKU编号'"
              >
                <el-input
                  v-model.trim="form.evgSkuNo"
                  :placeholder="
                    $l('header_placeholder_evgSkuNo') || '请输入产品SKU编号'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('header_label_eanCode') || '产品EAN条码'"
              >
                <el-input
                  v-model.trim="form.eanCode"
                  :placeholder="
                    $l('header_placeholder_eanCode') || '请输入产品EAN条码'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('header_label_goodsName') || '产品中文名称'"
              >
                <el-input
                  v-model.trim="form.goodsName"
                  :placeholder="
                    $l('header_placeholder_goodsName') || '请输入产品中文名称'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('header_label_goodsNameEn') || '产品英文名称'"
              >
                <el-input
                  v-model.trim="form.goodsNameEn"
                  :placeholder="
                    $l('header_placeholder_goodsNameEn') || '请输入产品英文名称'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('header_label_whSkuNo') || '仓库SKU编号'"
              >
                <el-input
                  v-model.trim="form.whSkuNo"
                  :placeholder="
                    $l('header_placeholder_whSkuNo') || '请输入仓库SKU编号'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('header_label_whSkuBarcode') || '仓库条码号'"
              >
                <el-input
                  v-model.trim="form.whSkuBarcode"
                  :placeholder="
                    $l('header_placeholder_whSkuBarcode') || '请输入仓库条码号'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('header_label_whReferenceNo') || '自定义编号'"
              >
                <el-input
                  v-model.trim="form.whReferenceNo"
                  :placeholder="
                    $l('header_placeholder_whReferenceNo') || '请输入自定义编号'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('header_label_whProductTitle') || '仓库产品中文名称'"
              >
                <el-input
                  v-model.trim="form.whProductTitle"
                  :placeholder="
                    $l('header_placeholder_whProductTitle') ||
                      '请输入仓库产品中文名称'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="
                  $l('header_label_whProductTitleEn') || '仓库产品英文名称'
                "
              >
                <el-input
                  v-model.trim="form.whProductTitleEn"
                  :placeholder="
                    $l('header_placeholder_whProductTitleEn') ||
                      '请输入仓库产品英文名称'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('header_label_ecomWarehouseCode') || '海外仓库'"
                prop="ecomWarehouseCode"
              >
                <dict-select
                  v-model="form.ecomWarehouseCode"
                  url="/ecom/warehouse/warehouse/select/overseas"
                  :placeholder="
                    $l('header_placeholder_ecomWarehouseCode') ||
                      '请选择海外仓库'
                  "
                  filterable
                  clearable
                  style="width:100%"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_shelves_whAccount') || '仓库账号'"
                prop="whAccount"
              >
                <dict-select
                  v-model="form.whAccount"
                  url="/ecomorder/overseas/inv/sku/set/select/account/all"
                  :placeholder="
                    $l('placeholder_shelves_select_whAccount') ||
                      '请选择仓库账号'
                  "
                  filterable
                  clearable
                  style="width:100%"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-row :gutter="0">
                <el-form-item
                  :label="$l('header_label_created_date') || '创建时间'"
                >
                  <br />
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginCreateTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('header_placeholder_cs_date') || '选择日期'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endCreateTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('header_placeholder_ce_date') || '选择日期'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-row :gutter="0">
                <el-form-item :label="$l('header_label_time') || '修改时间'">
                  <br />
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginModifyTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('header_placeholder_ms_date') || '选择日期'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endModifyTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('header_placeholder_me_date') || '选择日期'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('header_label_createBy') || '创建人'"
                prop="createBy"
              >
                <dict-select
                  v-model="form.createBy"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('header_placeholder_createBy') || '请选择创建人'
                  "
                  clearable
                  filterable
                  size="mini"
                  style="width:100%"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('header_label_modifyBy') || '修改人'"
                prop="modifyBy"
              >
                <dict-select
                  v-model="form.modifyBy"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('header_placeholder_modifyBy') || '请选择修改人'
                  "
                  clearable
                  filterable
                  size="mini"
                  style="width:100%"
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span class="footer mt-2 mb-4">
          <el-button size="mini" @click="closeAdvqueryDialog">
            {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
          </el-button>
          <el-button size="mini" type="warning" @click="reset">
            {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
          </el-button>
          <el-button size="mini" type="primary" @click="advquery">
            {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
          </el-button>
        </span>
      </div>
    </el-drawer>
  </div>
</template>

<script>
// 初始表单
const initForm = { keyword: '', invSkuSetStatusList: ['N', 'W', 'Y'] }
export default {
  props: { checkedCount: { type: Number, default: 0 } },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      masterCategoryParams: { parentCode: 'ABSHome' },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
.footer {
  display: flex;
  justify-content: end;
}
</style>
